import { render } from "./Experiences.vue?vue&type=template&id=5a9036b8"
import script from "./Experiences.vue?vue&type=script&lang=js"
export * from "./Experiences.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__